import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';

import { getChannelBookmark } from '../../../api/channels';

import { generateChannelCIDKey } from '../../../utils/generateChannelCIDKey';
import {
  checkAndSetLoadingWithId,
  handleRequestRejection,
  onMatchedRequest,
} from '../../../utils/asyncThunkRequest';

export const fetchChannelBookmark = createAsyncThunk(
  'channels/fetchChannelBookmark',
  async ({ path }, { signal, rejectWithValue }) => {
    const source = axios.CancelToken.source();
    signal.addEventListener('abort', () => {
      source.cancel();
    });
    try {
      const response = await getChannelBookmark(
        { path },
        {
          cancelToken: source.token,
        },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.status);
    }
  },
);

export const fetchChannelBookmarkExtraReducers = builder => {
  builder
    .addCase(fetchChannelBookmark.pending, (state, action) => {
      checkAndSetLoadingWithId(
        state.channels.bookmark.request,
        action,
        generateChannelCIDKey(action.meta.arg.path),
      );
    })
    .addCase(fetchChannelBookmark.fulfilled, (state, action) => {
      const channelCIDKey = generateChannelCIDKey(action.meta.arg.path);

      onMatchedRequest(
        state.channels.bookmark.request[channelCIDKey],
        action,
        () => {
          state.channels.bookmark.byId[channelCIDKey] = {
            isBookmark: action.payload,
            selectedTags: [],
          };

          if (!state.channels.bookmark.allIds.includes(channelCIDKey)) {
            state.channels.bookmark.allIds.push(channelCIDKey);
          }
        },
      );
    })
    .addCase(fetchChannelBookmark.rejected, (state, action) => {
      handleRequestRejection(
        state.channels.bookmark.request[
          generateChannelCIDKey(action.meta.arg.path)
        ],
        action,
      );
    });
};
